<template>
  <v-dialog
    v-model="dialog"
    max-width="800px"
    @click:outside="$emit('changeValue', false)"
    @keydown="$emit('changeValue', false)"
  >
    <v-card>
      <v-card-title class="headline">
        <slot name="title" />
      </v-card-title>
      <v-card-text>
        <span v-if="messages.length == 0 && !newMessagesDelivered" style="font-size: 14px">
          Carregando mensagens... por favor, aguarde.
        </span>
        <table v-else id="dialog-acompanhamento--table">
          <thead>
            <tr>
              <th style="text-align: initial">Mensagens de andamento</th>
            </tr>
          </thead>
          <tbody id="dialog-acompanhamento--t-body">
            <tr v-for="(message, i) in filteredMessages" :key="i">
              <td>{{ message }}</td>
            </tr>
          </tbody>
        </table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import pusherMixins from '@/mixins/pusherMixins';

  export default {
    mixins: [pusherMixins],

    props: {
      showDialog: {
        type: Boolean,
        required: true
      },
      messages: {
        type: Array,
        required: true
      },
      nameEventPusher: {
        type: String,
        default: ''
      }
    },

    emits: ['changeValue'],

    data() {
      return {
        dialog: false,
        newMessagesDelivered: false,
        liveMessages: [],
        boundEvent: null
      };
    },

    computed: {
      filteredMessages() {
        const historico = this.messages.filter((msg) => String(msg).trim() !== '');
        const aoVivo = this.liveMessages.filter((msg) => String(msg).trim() !== '');
        return aoVivo.concat(historico);
      }
    },

    watch: {
      showDialog(newValue) {
        if (newValue == false) {
          this.disablePusherEvent();
          this.newMessagesDelivered = false;
        }
        this.liveMessages = [];
        this.dialog = newValue;
      }
    },

    methods: {
      activatePusher() {
        this.newMessagesDelivered = false;
        this.liveMessages = [];
        this.disablePusherEvent();
        this.boundEvent = this.nameEventPusher;
        this.pusherChannel.bind(this.boundEvent, (data) => {
          this.addNewRow(data.message);
        });
      },
      markLoaded() {
        this.newMessagesDelivered = true;
      },
      disablePusherEvent() {
        if (this.boundEvent) {
          this.pusherChannel.unbind(this.boundEvent);
          this.boundEvent = null;
        }
      },
      addNewRow(message) {
        if (!message || !String(message).trim()) return;

        this.newMessagesDelivered = true;
        this.liveMessages.unshift(message);
      }
    }
  };
</script>

<style>
  #dialog-acompanhamento--table {
    width: 100% !important;
  }

  #dialog-acompanhamento--t-body th,
  #dialog-acompanhamento--t-body td {
    border-bottom: 1px solid rgb(211, 210, 210) !important;
    padding: 4px !important;
    text-align: justify !important;
    font-size: 14px !important;
  }
</style>
